<template>
  <div id="register">
    <div class="xxgfPage">
      <div class="xxgfPageImg"><img src="../assets/img/logo.png" alt=""></div>
      <div class="xxgfPageText">注册APP 获取学分领奖励</div>
    </div>
    <div class="infoPage">
      <input
        type="text"
        class="input1"
        placeholder="请输入手机号"
        v-model="phone"
      />
      <div class="inputCode">
        <input
          type="text"
          class="input2"
          placeholder="请输入验证码"
          v-model="code"
        />
        <span class="code" @click="getCode" v-if="countTime === 61">获取验证码</span>
        <span class="code" v-else>{{countTime}}秒</span>
      </div>
      <div>
        <input
          type="password"
          class="input1"
          placeholder="请设置登录密码"
          v-model="password"
        />
      </div>
      <div class="agree">
        注册即表示同意
        <router-link to="/agreement" tag="span" style="color:#E22B1C">《用户协议》</router-link>
      </div>
      <div class="register" @click="register">点击注册</div>
      <div class="register" v-if="type" @click="openApp">已有账号，打开APP</div>
    </div>
    <div class="download_wrap">
      <div class="left_wrap">
        <img class="logo" src="../assets/img/logo_1.png" alt="">
        <div class="name">学习国防</div>
      </div>
      <router-link to="/download" tag="div" class="btn">下载App</router-link>
    </div>
    <div class="mcover" v-if="show">
      <p class="text">{{isIos() ? '请在safari浏览器中打开页面进行操作' : '请在系统自带浏览器中打开页面进行操作'}}</p>
      <div class="close" @click="closePage">我知道了</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "register",
  data() {
    return {
      invite: this.$route.query.invite,
      type: this.$route.query.type,
      phone: '',
      password: '',
      code: '',
      countTime: 61,
      show: false
    };
  },
  methods: {
    getCode () {
      let phoneRule = /^1[3-9]\d{9}$/;
      if (!this.phone) return this.Toast('请输入手机号');
      if (!phoneRule.test(this.phone)) return this.Toast('手机号格式不正确');
      this.axios.get('/xxgf-api/user/verification/code?phoneNumber=' + this.phone)
        .then(({data}) => {
          if (data.code === 200) {
            this.Toast('发送成功');
            this.countDown();
          } else {
            this.Toast(data.msg);
          }
        })
    },
    countDown () {
      this.countTime--;
      this.timer = setInterval(() => {
        this.countTime--;
        if (this.countTime <= 0) {
          window.clearInterval(this.timer);
          this.countTime = 61;
        }
      }, 1000);
    },
    register () {
      let phoneRule = /^1[3-9]\d{9}$/;
      if (!this.phone) return this.Toast('请输入手机号');
      if (!phoneRule.test(this.phone)) return this.Toast('手机号格式不正确');
      if (!this.password) return this.Toast('请输入登录密码');
      if (!this.code) return this.Toast('请输入验证码');
      let dat = JSON.stringify({
        type: 0,
        user: {
          phoneNumber: this.phone,
          password: this.password,
          inviteUserId: this.invite
        },
        userRegister: {},
        verificationCode: this.code
      })
      this.axios.post('/xxgf-api/user/register', dat, {headers: {'Content-Type': 'application/json;charset=UTF-8'}, transformRequest: [function (data) { return data; }]})
        .then(({data}) => {
          if (data.code === 200) {
            this.Toast('注册成功');
            setTimeout(() => {
              this.$router.push('/download');
            }, 1000);
          } else {
            this.Toast(data.msg);
          }
        })
    },
    closePage() {
      this.show = false;
    },
    openApp () {
      if (this.isWechat()) {
        this.show = true;
      } else {
        if (this.isIos()) {
          window.location.href = "studydefense://joinStudyGroup";
        } else {
          window.location.href = "android://h5/open?type=1&id=7";
        }
      }
    }
  }
};
</script>
<style lang="scss">
#register {
  background:#fff;
  padding-top: 160px;
  .xxgfPage {
    width: 100%;
    .xxgfPageImg {
      width: 300px;
      height: 140px;
      margin: 0 auto;
      background-size: 100% 100%;
    }
    .xxgfPageText {
      width: 100%;
      text-align: center;
      font-size: 32px;
      font-family: PingFangSC;
      font-weight: 500;
      color: rgba(215, 47, 29, 1);
      margin-top: 30px;
    }
  }
  .infoPage {
    width: 90%;
    font-size: 36;
    font-family: PingFangSC;
    font-weight: 400;
    margin: 50px auto 0;
    input {
      border: 1px solid #dddddd;
      height: 90px;
      width:100%;
      margin-bottom: 40px;
      border-radius: 8px;
      padding: 0 20px;
      color: #333;
    }
    .inputCode {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .input2 {
      width: 64% !important;
    }
    .code {
      width: 32%;
      height: 90px;
      background: rgba(215, 47, 29, 1);
      border-radius: 4px;
      font-size: 34px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 90px;
      text-align:center;
    }
    .agree {
      font-size: 32px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(170, 170, 170, 1);
    }
    .register {
      width: 100%;
      height: 90px;
      background: rgba(215, 47, 29, 1);
      border-radius: 4px;
      font-size: 34px;
      font-family: PingFangSC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 90px;
      margin-top: 50px;
      text-align:center;
    }
  }
  .mcover{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba($color: #000000, $alpha: 0.8) url('../assets/img/icon_fenxiang_jiantou.png') no-repeat 560px 20px / 128px 100px;
    padding-top:200px;
    color:#fff;
    .text{
      font-size:40px;
      line-height:60px;
      padding: 0 100px;
    }
    .close{
      width:200px;
      height:80px;
      line-height:80px;
      text-align:center;
      margin:200px auto 0;
      background:gray;
      border-radius: 20px;
    }
  }
}
</style>
